import MDBox from "components/MDBox";
import { Job, JobStatus } from "generated/graphql";
import CompanySection from "./CompanySection";
import JobCostSummarySection from "./JobCostSummarySection";
import JobStatusStepper from "./JobStatusStepper";
import DirectCostsSummarySection from "./DirectCostsSummaryTable";
import ProductSummarySection from "./ProductSummarySection";
import StackSection from "./Stack";
import MaterialOrLabourSummarySection from "./MaterialOrLabourSummarySection";

export default function View({ job, onClose }: { job: Job; onClose?: () => void }) {
  return (
    <>
      <JobStatusStepper jobId={job.id} status={job.status as JobStatus} />
      <MDBox my={4}>
        <StackSection
          proposalId={job.proposalId}
          externalId={job.externalId}
          proposal={job.proposal}
          jobId={job.id}
          job={job}
          shouldPushTaxesToQuickbooks={job.shouldPushTaxesToQuickbooks}
          mayShowTaxNotification={job.mayShowTaxNotification}
        />
      </MDBox>
      <MDBox my={4}>
        <CompanySection job={job} />
      </MDBox>
      <MDBox my={4}>
        <ProductSummarySection phases={job.jobPhases} onClose={onClose} />
      </MDBox>
      <MDBox my={4}>
        <JobCostSummarySection job={job} />
      </MDBox>
      <MDBox my={4}>
        <DirectCostsSummarySection job={job} />
      </MDBox>
      <MDBox my={4}>
        <MaterialOrLabourSummarySection proposedLabourHours={1} phases={job.jobPhases} />
      </MDBox>
    </>
  );
}
